import PaymentIcon from 'assets/img/store/payment.svg';
import IntegrationIcon from 'assets/img/store/integration.svg';
import BarChartIcon from 'assets/img/store/barChart.svg';
import AovGraph from 'assets/img/store/AOV-graph.svg';
import { InfoCard } from 'components/stores/InfoCard';

const Info = () => {
  return (
    <div className="hidden lg:flex w-1/2 bg-light-green-bg items-center justify-center px-4">
      <div className="min-w-xl max-w-2xl">
        <div className="flex flex-col mb-9 gap-5">
          <InfoCard icon={PaymentIcon} iconBg="#CFDEED" className="mr-auto">
            <span className="text-sm font-normal leading-5 text-gray-blue-70">
              <span className="font-semibold">
                Greatest number of compliant and redundant{' '}
              </span>
              solutions in cannabis payments with new providers added frequently
            </span>
          </InfoCard>
          <InfoCard icon={IntegrationIcon} iconBg="#FBF1CF" className="ml-auto">
            <span className="text-sm font-normal leading-5 text-gray-blue-70">
              <span className="font-semibold">
                Fast and frictionless onboarding{' '}
              </span>
              of all solutions via one, universal application called TreezPay
              OneApp
            </span>
          </InfoCard>
          <InfoCard icon={BarChartIcon} iconBg="#F1D9D9" className="mr-auto">
            <span className="text-sm font-normal leading-5 text-gray-blue-70">
              <span className="font-semibold">Fully Integrated </span>
              transactions allow for 100% reporting visibility and seamless
              reconciliation of all payment types via TreezPay Portal
            </span>
          </InfoCard>
        </div>

        <div>
          <div className="mb-5 text-base font-medium text-medium-gray">
            Unlock higher AOV with cashless payments
          </div>
          <div className="flex flex-row mb-9 justify-between gap-3">
            <img src={AovGraph} alt="Average Order Value Graph" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Info;
